module.exports = __webpack_public_path__ + "static/health-clinics-3b6359568863aeba9bd998c53b5afd63.png";